export class VehicleModel {
    Id!: number;
    NameModel!: string;
    IsAvailable!: boolean;
    VehicleBrandId!: number;
    VehicleId!: number;

    constructor(payload?: { [key: string]: any }) {
        Object.assign(this, payload);
    }

    static mapToVehicleModels(models: any[]): VehicleModel[] {
        return models.map((model: VehicleModel) => new VehicleModel(model));
    }
}
